import { useDb } from '@/composables/useDb'

export const useSalidaService = () => {
  const db = useDb()

  const saveSalida = async (form, mapData) => {
    const key = await db.generateRandomKey()
    const hasDate = !!form.date
    const dateMs = hasDate
      ? (form.date instanceof Date ? form.date.getTime() : new Date(form.date).getTime())
      : Date.now()
    const salida = {
      ...form,
      id: Date.now(),
      key,
      date: hasDate ? dateMs : form.date, // sin fecha: se preserva la ausencia, no se muestra una falsa
      validUntil: new Date(dateMs + 7 * 24 * 60 * 60 * 1000),
    }

    let mapId
    try {
      mapId = await db.createDoc('maps', { ...salida, dataMap: mapData }, key)
    } catch {
      return { data: null, error: 'No se pudo guardar el mapa de la salida' }
    }

    const linkDoc = {
      puntosEncuentro: salida.puntoEncuentro,
      validUntil: new Date(dateMs + 1 * 24 * 60 * 60 * 1000),
    }

    let linkId
    try {
      linkId = await db.createDoc('links', linkDoc, key)
    } catch {
      return { data: null, error: 'No se pudo guardar el link de la salida' }
    }

    return { data: { ...salida, mapId, linkId }, error: null }
  }

  return { saveSalida }
}
